import * as React from "react";
import "./primaryButton.scss";
import { classNames } from "../../utils";
import ButtonBase from "@mui/material/ButtonBase";

interface IPrimaryButtonProps {
  text: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  children?: JSX.Element | JSX.Element[];
}

const PrimaryButton: React.FC<IPrimaryButtonProps> = (props) => {
  const { style, className, onClick, disabled } = props;
  const buttonElem = React.useRef(null);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <ButtonBase
      disabled={disabled}
      ref={buttonElem}
      onClick={handleClick}
      color={"white"}
      className={classNames({
        "primary-button": true,
        "primary-button--disabled": disabled,
        [className]: !!className,
      })}
      style={{ ...(style ? style : {}) }}
    >
      <div>{props.text && <span>{props.text}</span>}</div>
    </ButtonBase>
  );
};

export default PrimaryButton;
